module.exports = __webpack_public_path__ + "static/media/YF79_3.a4615aa1.jpg";